import { render, staticRenderFns } from "./Case1.vue?vue&type=template&id=6865016c&scoped=true"
import script from "./Case1.vue?vue&type=script&lang=js"
export * from "./Case1.vue?vue&type=script&lang=js"
import style0 from "./Case1.vue?vue&type=style&index=0&id=6865016c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6865016c",
  null
  
)

export default component.exports